module.exports = __webpack_public_path__ + "static/media/image-3.89cf6288.png";